import React from 'react';
import { handleDocumentoUpload } from './functions';
import { Erro } from '../../pages/Cliente/AlteracaoSenha/AlteracaoSenha';
import { UploadDocumento } from './UploadDocumentos';
import { Link } from 'react-router-dom';

export interface ImagensDocumentacao {
    tipoDocumento: string;
    conteudo: string | ArrayBuffer | null;
    nomeArquivo: string;
    tamanho: string;
    dataUpload: string;
}

interface CadastroDocumentosProps {
    tipoPessoa: string;
    setImagensDocumentacao: React.Dispatch<React.SetStateAction<Array<ImagensDocumentacao>>>;
    setError: React.Dispatch<React.SetStateAction<Erro>>;
    setCompromisso: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CadastroDocumentos = ({
    tipoPessoa,
    setImagensDocumentacao,
    setError,
    setCompromisso,
}: CadastroDocumentosProps) => {

    const handleUpload = (
        e: React.ChangeEvent<HTMLInputElement>,
        tipoDocumento: string
    ) => {
        handleDocumentoUpload(
            e,
            tipoDocumento,
            setError,
            setImagensDocumentacao
        );
    };

    return (
        <div>
            <h3 className="TextoTitulo">DOCUMENTAÇÃO</h3>

            <div className="Area_ServicoDocumentacao">
                <h5 className="TextoSubTitulo">Anexe os documentos necessários</h5>
            </div>

            <div className="Area_DocumentosAnexos">
                {tipoPessoa === "PessoaFisica" ? (
                    <UploadDocumento
                        label="Documento com CPF"
                        tipoDocumento="CPF"
                        obrigatorio
                        onUpload={handleUpload}
                    />
                ) : (
                    <>
                        <UploadDocumento
                            label="Cartão CNPJ"
                            tipoDocumento="CNPJ"
                            obrigatorio
                            onUpload={handleUpload}
                        />
                        <UploadDocumento
                            label="Contrato social"
                            tipoDocumento="ContratoSocial"
                            onUpload={handleUpload}
                        />
                    </>
                )}

                <UploadDocumento
                    label="Comprovante de residência"
                    tipoDocumento="ComprovanteDeResidencia"
                    obrigatorio={tipoPessoa === "PessoaFisica"}
                    onUpload={handleUpload}
                />

                <div>
                    <input
                        type="checkbox"
                        id="chkCobrarTaxas"
                        name="chkCobrarTaxas"
                        onChange={(e) => setCompromisso(e.target.checked)}
                    />
                    <label htmlFor="chkCobrarTaxas" className="espacamentoCheckbox">
                        Declaro que li e aceito os{" "}
                        <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            to="/termos-de-uso"
                        >
                            termos de compromisso.
                        </Link>
                    </label>
                </div>
            </div>
        </div>
    );
};
